import { Component, OnInit } from '@angular/core';
import {NavigationConstant} from '@constant/navigation.constant';
import {Router} from '@angular/router';
import { ParentHelper } from '@helper/parent.helper';

@Component({
  selector: 'app-shopee-pay',
  templateUrl: './shopee-pay.component.html',
  styleUrls: ['./shopee-pay.component.css']
})
export class ShopeePayComponent implements OnInit {

  count: number = 0;

  constructor(
      private router: Router
  ) { }

  ngOnInit(): void {
  }
  goHome(){
    ParentHelper.navigate(NavigationConstant.HOME_REDIRECT);
    if(this.count >= 1){
      // this.router.navigate([NavigationConstant.HOME_BO]);
      window.location.href =  window.location.origin+NavigationConstant.HOME_BO;
    }
    this.count++;
  }
}
